//
// rest api
//

// xit_alpha2が設置されているサーバを指定する
let _api_url = '★管理サーバのURL'
// 例)let _api_url = 'https://shabelab-management.de-call.center'


let _stripe_key = ""
export const API_URL = _api_url
export const API_KEY = 'szFx0FbatrocDeeb'
export const LOCAL_STRAGE_KEY = "__ALPHA_SHABELAB__"
export const STRIPE_KEY = _stripe_key
